import {Component, OnInit} from '@angular/core';
import {AppMessageService} from "../../shared/services/app-message/app-message.service";
import {AppMessageType} from "../../shared/services/app-message/app-message";

@Component({
  selector: 'app-toastr',
  templateUrl: './toastr.component.html',
  styleUrl: './toastr.component.scss',
})
export class ToastrComponent implements OnInit {
  public header: string;
  public message: string;
  public type: string;
  public showToast: boolean = false;
  public toastDuration: number;
  public toastPosition: string;
  public animationDuration: string;

  constructor(private readonly appMessageService: AppMessageService) {

  }

  ngOnInit(): void {
    this.appMessageService.eventSource.subscribe((res) => {
      this.header = res.header;
      this.message = res.message;
      this.toastDuration = res.toastDuration;
      this.toastPosition = res.toastPosition;
      this.setType(res.messageType);
      this.animationDuration = this.toastDuration / 1000 + 's';
      this.show();
    });
  }

  private show(): void {
    this.showToast = true;

    setTimeout(() => {
      this.closeToast();
    }, this.toastDuration);
  }

  closeToast(): void {
    this.showToast = false;
  }

  private setType(messageType: AppMessageType): void {
    switch (messageType) {
      case AppMessageType.successToast:
        this.type = 'toast-success';
        break;
      case AppMessageType.infoToast:
        this.type = 'toast-info';
        break;
      case AppMessageType.warningToast:
        this.type = 'toast-warning';
        break;
      case AppMessageType.errorToast:
        this.type = 'toast-error';
        break;
      default:
        this.type = 'toast-info';
        break;
    }
  }
}
